<template>
<el-row>
  <el-col>
    <span class="cs-title">积分记录 </span>
    <span class="cs-blue cs-accountList-viewDetail"
          @click="viewDetails">
      查看明细
      <i class="fa fa-chevron-down"
         v-if="!isShowDetails"
         aria-hidden="true"></i>
      <i class="fa fa-chevron-up"
         v-if="isShowDetails"
         aria-hidden="true"></i>
    </span>
    <el-row class="hidden-xs-only">
      <el-col :span="18">
        <label> &nbsp; </label>
      </el-col>
    </el-row>
    <el-row class="grid-content" v-if="isShowDetails">
      <el-col :span="22" :xs="24">
        <el-table ref="bounsPointHistory" :data="bounsPointHistory" :header-row-class-name="'el-table-header'" :cell-class-name="cellStyle">
          <el-table-column prop="DateString" label="日期" class-name="courses-history-colmun-width">
          </el-table-column>
          <el-table-column prop="Amount" label="数量" class-name="courses-history-colmun-width">
          </el-table-column>
          <el-table-column prop="Note" label="备注" class-name="courses-history-colmun-width">
          </el-table-column>


        </el-table>
      </el-col>
    </el-row>
  </el-col>

</el-row>
</template>

<style>

.cs-accountList-viewDetail {
            cursor: pointer;
          }
</style>

<script>
import {
    getStudentBounsPointHistory
} from "../../service/student.service";
let moment = require("moment");
export default {
    props: ["studentId"],
    data() {
        return {
            fileData:"",
          bounsPointHistory: [],
          isShowDetails: false,
        }
    },
    created() {
        this.initData();
    },
    methods: {
        cellStyle(cell) {
            let cellClass = "";
            if ((cell.rowIndex + 1) % 2 == 1) {
                cellClass = "el-table-cell-single";
            } else {
                cellClass = "el-table-cell-double";
            }
            return cellClass;
        },
        initData() {
            getStudentBounsPointHistory(this.studentId).then(result => {
                if (!!result && result.success) {
                  this.bounsPointHistory = result.data;
                  this.bounsPointHistory.forEach(element => {
                    if (element.Note != "现有积分") {
                       if (element.Increased ) {
                          element.Amount = "+" + element.Amount;
                        } else {
                          element.Amount = "-" + element.Amount;
                      }
                      element.DateString = moment(moment.utc(element.Date).toDate()).format('YYYY/MM/DD');
                    }
                   

                  });
                }
            });
          
      }, viewDetails() {
        this.isShowDetails = !this.isShowDetails;
          
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/studentProfile/studentBounsPointHistory.vue